// extracted by mini-css-extract-plugin
export default {"row":"Header_row__2m+s4","title":"Header_title__HtaAW","content":"Header_content__tGrug"};